import { createContext } from 'react';
import { IHomeContext } from './homeDetail';

export type HomeContextProps = {
  homeState: IHomeContext;
  setHomeState: Function;
};

export const HomeContext = createContext({} as HomeContextProps);
